<div style="margin-top: 30px;">
<form [formGroup]="myForm" (ngSubmit)="onSubmit()"  novalidate>

    <!--  <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px">  DEPCRICATED-->
    <div class="flex-container">

    <div>
      <mat-card style="width: 300px; height: 100%;">
        <mat-toolbar color="primary" class="mat-elevation-z16">
          <mat-toolbar-row>
            <span>Login</span>
          </mat-toolbar-row>
        </mat-toolbar>


        <mat-card-content >  <!-- fxLayout="column" -->
          <mat-form-field style="margin-top: 15px; width: 100%">
            <mat-label>Email:</mat-label>
            <input matInput type="email" placeholder="me@user.com" (focus)="onFocus()" formControlName="username" autocomplete="email">
            <mat-error>
              <strong>Valid email address required</strong>
            </mat-error>
          </mat-form-field>
          <mat-form-field style="margin-top: 15px; width: 100%">
            <mat-label>Password:</mat-label>
            <input matInput [type]="hide ? 'password' : 'text'" placeholder="password" (focus)="onFocus()" formControlName="password" autocomplete="current-password">
            <button type="button" mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
              <mat-icon class="add-button">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
            <mat-error>
              <strong>Valid password required</strong>
            </mat-error>
          </mat-form-field>
        </mat-card-content>
        <div *ngIf="is_form_error">
            <mat-error style="margin-bottom: 5px">
              <strong>{{form_error_message}}</strong>
            </mat-error>
        </div>



        <button mat-raised-button color="accent" [disabled]="!myForm.valid" type="submit">Login</button>
        <a style="margin-left: 10px" routerLinkActive="active" [routerLink]="['/forgot-password']">Forgot Password</a>

        <mat-progress-bar *ngIf="is_loading" mode="indeterminate" style="margin-top: 10px"></mat-progress-bar>
      </mat-card>
    </div>
  </div>

</form>
</div>
